import { useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

export function useGoTo() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  return (id) => {
    if (pathname === "/") scrollToId(id);
    else nav("/", { state: { scrollTo: id } });
  };
}
